<template>
    <div class="about-collection-items">
        <carousel :items="items" :options="options" :show-navigation="showNavigation">
            <template #slide="{ item }">
                <div class="about-collection-item">
                    <img :src="item.path" :alt="item.title">
                </div>
            </template>
        </carousel>
    </div>
</template>
<script>
import Carousel from "./Carousel.vue";
import windowWidth from "../../mixins/windowWidth";

export default {
    props: ['items'],
    components: {
        Carousel
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            showNavigation: false,
            options: {
                spaceBetween: 10,
                loop: false,
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                },
            },
        }
    },
    mounted() {
        this.showNavigation = windowWidth < 1024;
    },
    watch: {
        windowWidth (val) {
            this.showNavigation = val < 1024;
        }
    }
}
</script>
